import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { useAuth } from 'context/AuthContext';

const OverallProgressCard = ({
  totalChapters = 4,
}) => {
  const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  const { courseOverview, getCourseOverview } = useAuth()


  useEffect(() => {
    getCourseOverview();
  }, []);


  const totalSlidesofChapters = courseOverview?.coursesProgress?.reduce((acc, course) => {
    return acc + (course?.progress || 0);
  }, 0) || 0;

  const progressPercent = (totalSlidesofChapters / 400 * 100).toFixed(0);

  const getProgressColor = () => {
    if (progressPercent >= 80) return 'success';
    if (progressPercent >= 60) return 'secondary';
    if (progressPercent >= 40) return 'warning';
    return 'error';
  };

  const progressColor = getProgressColor();
  const circumference = 2 * Math.PI * 45;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (progressPercent / 100) * circumference;


  return (
    <div className="p-6 border bg-surface rounded-xl border-border card-shadow">
      <div className="flex flex-col items-center space-y-6 lg:flex-row lg:items-start lg:space-y-0 lg:space-x-8">
        {/* Circular Progress */}
        <div className="relative flex items-center justify-center">
          <svg className="w-32 h-32 transform -rotate-90" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="var(--color-border-light)"
              strokeWidth="8"
              fill="none"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke={`var(--color-${progressColor})`}
              strokeWidth="8"
              fill="none"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="progress-animation"
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-3xl font-bold font-heading text-text-primary">
              {progressPercent}%
            </span>
            <span className="text-sm text-text-secondary">Complete</span>
          </div>
        </div>

        {/* Progress Details */}
        <div className="flex-1 text-center lg:text-left">
          <h2 className="mb-2 text-2xl font-bold font-heading text-text-primary">
            Learning Progress
          </h2>
          <p className="mb-6 text-text-secondary">
            Track your journey through AI fundamentals and see how far you've come
          </p>

          {/* Key Metrics Grid */}
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            <div className="p-4 rounded-lg bg-primary-50">
              <div className="flex items-center justify-center w-8 h-8 mx-auto mb-2 rounded-lg bg-primary-100">
                <Icon name="BookOpen" size={16} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div className="mb-1 text-xl font-bold font-heading text-primary">
                {courseOverview?.completedCourses}/{totalChapters}
              </div>
              <div className="text-xs text-primary-700">Chapters</div>
            </div>

            <div className="p-4 rounded-lg bg-success-50">
              <div className="flex items-center justify-center w-8 h-8 mx-auto mb-2 rounded-lg bg-success-100">
                <Icon name="Target" size={16} color="var(--color-success)" strokeWidth={2} />
              </div>
              <div className="mb-1 text-xl font-bold font-heading text-success">
                {Math.round(courseOverview?.quizAvg)}%
              </div>
              <div className="text-xs text-success-700">Avg Score</div>
            </div>

            {/* <div className="p-4 rounded-lg bg-accent-50">
              <div className="flex items-center justify-center w-8 h-8 mx-auto mb-2 rounded-lg bg-accent-100">
                <Icon name="Flame" size={16} color="var(--color-accent)" strokeWidth={2} />
              </div>
              <div className="mb-1 text-xl font-bold font-heading text-accent">
                {learningStreak}
              </div>
              <div className="text-xs text-accent-700">Day Streak</div>
            </div> */}

            <div className="p-4 rounded-lg bg-secondary-50">
              <div className="flex items-center justify-center w-8 h-8 mx-auto mb-2 rounded-lg bg-secondary-100">
                <Icon name="Clock" size={16} color="var(--color-secondary)" strokeWidth={2} />
              </div>
              <div className="mb-1 text-xl font-bold font-heading text-secondary">
                {formatTime(courseOverview?.totalTimeSpentInMinutes || 0)}
              </div>
              <div className="text-xs text-secondary-700">Time Spent</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallProgressCard;